export const ACTIVITIES_MAIN_DATA = [
  {
    title: {
      ar: 'نشاط الكشافة',
      en: 'Scouts',
      fr: 'Flammes',
    },
    description: {
      ar: `من أقوال بادين-باول، مؤسس الكشافة، 
""أفضل طريقة لتحقيق السعادة هي أن تمنحها للآخرين. ""
"" السؤال ليس “ماذا يمكنني أن أحصل؟” بل “ماذا يمكنني أن أقدم في الحياة؟""
للمزيد من الأقوال، https://textoscout.weebly.com/citations.html
`,
      en: `Baden-Powell, the founder of Scouting, said...
""The best way to achieve happiness is to give it to others.""
""The question is not 'What can I get?' but 'What can I give in life?'""
For more quotes, https://textoscout.weebly.com/citations.html
`,
      fr: `Baden-Powell, le fondateur du scoutisme, a dit...

« La meilleure manière d’atteindre le bonheur est de le donner aux autres. »

« La question n’est pas “qu’est-ce que je peux avoir ?” mais “qu’est-ce que je peux donner dans la vie ? »

Pour plus de citations, https://textoscout.weebly.com/citations.html`,
    },
    image: 'scout.jpg',
    attachments: [], // TODO: Attach scout.jpg
    link: 'activities/scouts',
    type: 'activities',
    order: 6,
    isArchived: false,
  },
  {
    title: {
      ar: 'نشاط أغصان الكرمة',
      en: 'MEJ',
      fr: 'MEJ',
    },
    description: {
      ar: `أغصان الكرمة هو نشاط تعليمي بشري وروحي كاثوليكي. يعتمد المشروع التعليمي على التنمية الشاملة للشخص حتى يتمكن كل شاب من الربط بين حياته وإيمانه.
تاريخ أغصان الكرمة MEJ...
نحن في عام 1844، وفي تلك الفترة كان الذهاب في مهمة تبشيرية في غاية الأهمية: متابعة المسيح إلى أقصى حد ممكن للتبشير ولقاء شعوب لم تكن معروفة حتى ذلك الحين كان هو المثالي لكل مؤمن! ولكن في بيت تكويني لجماعة اليسوعيين في فالس-بري-لو-بوي (وسط فرنسا)، بدأ الإحباط يظهر بين الطلاب: لا توجد مهمة لهؤلاء اليسوعيين المستقبليين، بل ساعات طويلة من الدراسة في حياة تبدو عادية أمام إنجازات بعض المبشّرين.
https://www.mej.fr/accueil-2/le-mouvement/histoire/ 
`,
      en: `The MEJ is a Catholic movement for human and spiritual education. The educational project is based on the integral development of the person so that each young person can make the connection between their life and their faith.
The origin of the MEJ...
It is 1844, and at that time, going on mission was all the rage: following Christ as far as possible to evangelize and meet previously unknown populations was the ultimate goal for any believer! 
https://www.mej.fr/accueil-2/le-mouvement/histoire/
`,
      fr: `A l’origine du MEJ… 
Nous sommes en 1844 et à cette époque, partir en mission est très à la mode : suivre le Christ aussi loin que possible pour évangéliser et rencontrer des populations jusque-là inconnues est le nec plus ultra de tout croyant !.
https://www.mej.fr/accueil-2/le-mouvement/histoire/ 
`,
    },
    attachments: [], //TODO: Attach mej.jpg
    link: 'activities/scouts#MEJ_SECTION',
    image: 'mej.jpg',
    type: 'activities',
    order: 5,
    isArchived: false,
  },
  {
    title: {
      ar: 'النشاط الفني (الموسيقى والرسم)',
      en: 'Art (Music & Drawing)',
      fr: 'Art (Musique & Dessin)',
    },
    description: {
      ar: `عندما يجتمع الرسم والموسيقى!
""الموسيقى هي فن الأصوات، والرسم هو فن الألوان، لكن لا يوجد فن بدون مشاعر.""، جيوم أبولينير، شاعر وكاتب فرنسي ، 1880-1918`,
      en: `When drawing and music come together!
""Music is the art of sounds, painting is the art of colors, but there is no art without emotion.""
Guillaume Apollinaire, a French poet and writer (1880-1918)
`,
      fr: `Quand les arts plastiques et la musique se conjuguent!« La musique est l'art des sons, la peinture est l'art des couleurs, mais il n'y a pas d'art sans émotion. »
Guillaume Apollinaire, poète et écrivain français (1880-1918)
`,
    },
    attachments: [], // TODO : Attach art.jpg,
    link: 'activities/art',
    image: 'art.jpg',
    type: 'activities',
    order: 4,
    isArchived: false,
  },
  {
    title: {
      ar: 'النشاط الرياضي',
      en: 'Sport',
      fr: 'Sport',
    },
    description: {
      ar: `" ""الرياضة تعطي للجسد ما تعطيه القراءة للعقل.""
فرانسوا-رينيه دي شاتوبريان، كاتب فرنسي (1768-1848)
"`,
      en: `""Sport gives to the body what reading gives to the mind.""
François-René de Chateaubriand, French writer (1768-1848)
`,
      fr: `Le sport donne au corps ce que la lecture donne à l’esprit.", François-René de Chateaubriand, écrivain français (1768-1848)`,
    },
    attachments: [], // TODO : attach sport.png
    link: 'activities/sports',
    image: 'sport.png',
    type: 'activities',
    order: 3,
    isArchived: false,
  },
  {
    title: {
      ar: 'النشاط الاجتماعي',
      en: 'Social',
      fr: 'Social',
    },
    description: {
      ar: `
"" الحاجة إلى مساعدة بعضنا البعض تخلق الرفق، والتسامح المتبادل، وغياب أي تنافس "".
جورج ساند، روائية، كاتبة مسرح، رسائلية، ناقدة أدبية وصحفية فرنسية، 1804-1876)
`,
      en: `""The need to help each other generates kindness, mutual indulgence, and the absence of rivalry.""
(George Sand, French novelist, playwright, letter writer, literary critic, and journalist, 1804-1876)
`,
      fr: `« Le besoin de s’aider engendre la bienveillance, une indulgence mutuelle, l’absence de toute rivalité ». George Sand, romancière, dramaturge, épistolière, critique littéraire et journaliste française (1804-1876)`,
    },
    attachments: [], // TODO: Attach social.png
    link: 'activities/social',
    image: 'social.png',
    type: 'activities',
    order: 2,
    isArchived: false,
  },
  {
    title: {
      ar: 'النشاط المسرحي',
      en: 'Theatre',
      fr: 'Théâtre',
    },
    description: {
      ar: `
القرن السابع عشر
"" المسرح ليس سوى مكان للعرض. ""
موليير، أعظم كتّاب المسرح الفرنسي، 1622 - 1673
القرن التاسع عشر
`,
      en: `
17th century:
""The theater is made only to be seen.""
(Molière, the greatest French playwright, 1622–1673)
`,
      fr: `"Le théâtre n'est fait que pour être vu", Molière, le plus grand dramaturge français (1622 – 1673)`,
    },
    attachments: [], //TODO: Attach 'theatre.png',
    link: 'activities/theatre',
    image: 'theatre.png',
    type: 'activities',
    order: 1,
    isArchived: false,
  },
];
